export const COMPLETE_TASK_ERROR_MAP = {
	ALREADY_COMPLETED_ERROR: { code: 'ALREADY_COMPLETED_ERROR' },
	GRAPHQL_ERROR: { code: 'GRAPHQL_ERROR' },
	NO_DATA_ERROR: { code: 'NO_DATA_ERROR' },
	UNKNOWN_ERROR: { code: 'UNKNOWN_ERROR' },
	UNAUTHORIZED_ERROR: { code: 'UNAUTHORIZED_ERROR' },
} as const;

export const completeTaskErrorCodes = Object.keys(COMPLETE_TASK_ERROR_MAP) as ReadonlyArray<
	keyof typeof COMPLETE_TASK_ERROR_MAP
>;

// The actual tasks 'types' are defined in petition service, and may change.
// https://github.com/change/petition_service/blob/main/app/models/petition_task.rb#L12
// If there's a need to add a new task, make sure to update both places.
// More info: https://change.atlassian.net/wiki/x/aIC9EgE
export type TaskType =
	| 'complete_profile'
	| 'customize_link'
	| 'share_friends'
	| 'share_communities'
	| 'share_facebook'
	| 'share_instagram'
	| 'download_flyer'
	| 'thank_supporters'
	| 'promote_basic'
	| 'promote_high_performer'
	| (string & {});

export type CompleteTaskErrorCode = (typeof completeTaskErrorCodes)[number];
